// The fixed set of dispatch groups a dispatch-team member can flag an
// order with - why it isn't simply "ready to pack and ship normally".
// Keep in sync with DispatchGroup in the backend's
// orderDispatchGroup.entity.ts (plain varchar there too, so adding one
// here doesn't need a migration, just needs both lists updated together).
export interface DispatchGroupOption {
  value: string;
  label: string;
  icon: string;
  badgeClass: string;
}

export const DISPATCH_GROUPS: DispatchGroupOption[] = [
  { value: 'NO_STOCK', label: 'No Stock', icon: 'production_quantity_limits', badgeClass: 'bg-red-100 text-red-700' },
  { value: 'PRE_SALE', label: 'Pre-Sale', icon: 'hourglass_top', badgeClass: 'bg-indigo-100 text-indigo-700' },
  { value: 'OWN_DELIVERY', label: 'Own Delivery', icon: 'local_shipping', badgeClass: 'bg-purple-100 text-purple-700' },
  { value: 'COLLECTION', label: 'Collection', icon: 'storefront', badgeClass: 'bg-teal-100 text-teal-700' },
  { value: 'DELAYED_DISPATCH', label: 'Delayed Dispatch', icon: 'report_problem', badgeClass: 'bg-rose-100 text-rose-700' },
];

export function dispatchGroupOption(value: string | null | undefined): DispatchGroupOption | null {
  if (!value) return null;
  return DISPATCH_GROUPS.find((g) => g.value === value) || null;
}
